module.exports = __webpack_public_path__ + "static/img/modular-frame_256.a634307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modular-frame_256.png
// module id = kBWg
// module chunks = 0